import React, { Suspense } from 'react';
import { isNode } from '../../utils/micro-utils';

export default function loadable(promiseFunc, options?) {
  const WrappedComponent = React.lazy(promiseFunc);
  const resultOptions = Object.assign(
    {
      name: '',
      loadingVisible: false,
    },
    options,
  );
  const placeholderTpl = (
    <div
      style={{
        display: resultOptions.loadingVisible ? 'block' : 'none',
        padding: 10,
        textAlign: 'center',
      }}
    >
      {resultOptions.name} loading...
    </div>
  );

  if (isNode()) {
    return () => placeholderTpl;
  }

  return function(props) {
    return (
      <Suspense fallback={placeholderTpl}>
        <WrappedComponent {...props} />
      </Suspense>
    );
  };
}
